import { Box, Paper, Stack, Tab, Tabs, TextField } from '@mui/material';
import { useState } from 'react';

import { useT } from '../i18n/LanguageContext';

import { HtmlPreview } from './HtmlPreview';

type HtmlTextFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  maxLength: number;
  rows: number;
};

/**
 * A description in HTML (R0030 WP-05): typed in a plain field, previewed as a shop would show it. No editor
 * library — the allowed tags are few, and a textarea keeps exactly what is typed.
 */
export const HtmlTextField = ({ label, value, onChange, maxLength, rows }: HtmlTextFieldProps) => {
  const t = useT();
  const [mode, setMode] = useState<'edit' | 'preview'>('edit');

  return (
    <Stack spacing={0.5}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Tabs
          value={mode}
          onChange={(_event, next: 'edit' | 'preview') => setMode(next)}
          sx={{ minHeight: 32 }}
        >
          <Tab value="edit" label={t('products.htmlEdit')} sx={{ minHeight: 32, py: 0 }} />
          <Tab value="preview" label={t('products.htmlPreview')} sx={{ minHeight: 32, py: 0 }} />
        </Tabs>
      </Box>
      {mode === 'edit' ? (
        <TextField
          label={label}
          multiline
          minRows={rows}
          fullWidth
          value={value}
          helperText={t('products.htmlHint')}
          inputProps={{ maxLength, style: { fontFamily: 'ui-monospace, monospace', fontSize: 13 } }}
          onChange={(event) => onChange(event.target.value)}
        />
      ) : (
        <Paper variant="outlined" sx={{ p: 1.5, minHeight: rows * 22 }}>
          <HtmlPreview html={value} />
        </Paper>
      )}
    </Stack>
  );
};
